

















helpers = require('../../helpers.coffee')

view_model =
  mixins: [
    require('../../mixins/users_options.coffee')
    require('../../mixins/tags_options.coffee')
  ]

  props:
    filters:
      default: {}

  data: ->
    status_filter: @statusFilter()
    status_options: [
      { value: null, text: this.$t('businesses.label.statusOptions.all') }
      { value: { active_status: true }, text: this.$t('businesses.label.statusOptions.active') }
      { value: { bounced_status: true }, text: this.$t('businesses.label.statusOptions.bounced') }
      { value: { connected_status: true }, text: this.$t('businesses.label.statusOptions.connected') }
      { value: { uninitialized_status: true }, text: this.$t('businesses.label.statusOptions.uninitialized') }
      { value: { paused_status: true }, text: this.$t('businesses.label.statusOptions.') }
      { value: { converting_status: true }, text: this.$t('businesses.label.statusOptions.converting') }
      { value: { scheduled_status: true }, text: this.$t('businesses.label.statusOptions.scheduled') }
      { value: { interrupted_status: true }, text: this.$t('businesses.label.statusOptions.interrupted') }
      { value: { blocklisted_status: true }, text: this.$t('businesses.label.statusOptions.blocklisted') }
      { value: { not_connected_status: true }, text: this.$t('businesses.label.statusOptions.notConnected') }
      { value: { disqualified_status: true }, text: this.$t('businesses.label.statusOptions.disqualified') }
      { value: { inactive_status: true }, text: this.$t('businesses.label.statusOptions.inactive') }
    ],

    stage_filter: @extractFilter('stage_eq')
    stage_options: [
      { value: null, text: this.$t('businesses.label.stageOptions.all') }
      { value: { stage_query: 'smart_lead' }, text: this.$t('businesses.label.stageOptions.smartLead') }
      { value: { stage_query: 'prospect' }, text: this.$t('businesses.label.stageOptions.prospect') }
      { value: { stage_query: 'lead' }, text: this.$t('businesses.label.stageOptions.lead') }
      { value: { stage_query: 'mql' }, text: this.$t('businesses.label.stageOptions.mql') }
      { value: { stage_query: 'sql' }, text: this.$t('businesses.label.stageOptions.sql') }
      { value: { stage_query: 'opportunity' }, text: this.$t('businesses.label.stageOptions.opportunity') }
      { value: { stage_query: 'client' }, text: this.$t('businesses.label.stageOptions.client') }
      { value: { stage_query: 'lost' }, text: this.$t('businesses.label.stageOptions.lost') }
    ],

    tag_filter: @extractFilter('contacts_contact_tags_tag_id_eq')
    text_field_filter: @filters.search_query

  computed:
    filterParams: ->
      filter_params = {}
      for filter in [@status_filter, @stage_filter]
        Object.assign(filter_params, filter) if filter
      filter_params['search_query'] = @text_field_filter if @text_field_filter
      filter_params['contacts_contact_tags_tag_id_eq'] = @tag_filter.contact_tags_tag_id_eq if @tag_filter?.contact_tags_tag_id_eq?
      filter_params

  methods:
    filter: ->
      @$emit('filter', @filterParams)

    statusFilter: ->
      filter_keys = Object.keys(@filters).join()
      return unless filter_keys.match(/_status/)

      status_filter = {}
      for type in ['active_status', 'paused_status', 'scheduled_status'
                   'interrupted_status', 'uninitialized_status'
                   'blocklisted_status', 'not_connected_status', 'disqualified_status']
        status_filter[type] = true if @filters[type]
      status_filter

exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/businesses/filters.vue